import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6db325a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = { class: "worp_head" }
const _hoisted_3 = { class: "worp_operate" }
const _hoisted_4 = { class: "worp_footer_num" }
const _hoisted_5 = { class: "worp_content" }
const _hoisted_6 = { class: "worp_page" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formNmbertext formNmbertextmar" }, "手机号：", -1))
const _hoisted_8 = { class: "worp_end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "开启功能后，只能一个设备登录", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开启功能后，只能一个设备登录。", -1))
const _hoisted_11 = { class: "worp_swt" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开启功能后，只能在手机白名单中的观众才能观看直播。", -1))

import CDelModal from '@/components/CDelModal.vue';
import { RootModal } from '@/components/CDelModal.vue';
import { ref, computed, reactive, unref } from 'vue';
import { Input, Table, Radio, Popover, Modal, Upload, message, Pagination, notification } from 'ant-design-vue';
import { Key } from 'ant-design-vue/lib/_util/type';
import { useStore } from 'vuex';
import { getToken } from '@/plugins/cookie';
import router from '@/router';
import { getCurrentInstance } from 'vue';
import { QuestionCircleFilled, SearchOutlined } from '@ant-design/icons-vue';
import { useDebounce } from '@/hooks/useDebounce';
import { testArr } from '@/store/modules/authorizView/types';
import { useVirtualList } from '@vueuse/core'; //虚拟列表
import axios from '@/api';
import { WhiteObj } from './type';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList'




// 授权观看 ------ 白名单授权
const __default__ = { name: 'WhiteList' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const studioId = router.currentRoute.value.params.studioId;
const store = useStore();
const form = computed(() => store.state.authorizView.whiteView);

const updateForm = (type: number) => {
  if (form.value.whiteSwitch) {
    message.destroy();
    store.commit('authorizView/updateChildSwitch');
    if (!type) store.commit('authorizView/checkWhiteSwitch');
  }
  store.commit('authorizView/updateWhiteForm', form.value);
};

const aTable = Table;
const aInputSearch = Input.Search;
const aPagination = Pagination;
const aRadioGroup = Radio.Group;
const aPopover = Popover;
const aModal = Modal;
const aUpload = Upload;
let token = getToken();

const handleChange = (info: any) => {
  if (info.file.response.code === 200) {
    getWhiteList();
    message.success(` 导入成功！`);
  }
};

const fileList = ref([]);
const columns = [
  {
    title: '手机号',
    dataIndex: 'mobile',
    width: '',
    align: '',
    key: 'mobile',
  },
  {
    title: '删除',
    dataIndex: 'img',
    width: '130px',
    align: 'center',
    key: 'action',
    slots: { customRender: 'action' },
  },
];

const show = ref(false);
const newtel = ref<string>('');

//搜索
const renderList = ref<testArr[]>([]);
// const findChange = () => {
//   if (search.value) {
//     renderList.value = form.value.mobileWhiteList?.filter((e) => e.mobile.includes(search.value));
//   } else {
//     renderList.value = form.value.mobileWhiteList;
//   }
// };
const search = ref('');

//下载模板
const DownloadTemplate = () => {
  location.href = 'https://static.lighos.com/default/mobile.xlsx';
};
const { proxy }: any = getCurrentInstance();
const corn = ref(1);
const messageTip = ref();
const ExportTemplate = useDebounce(() => {
  const data = {
    studio_id: studioId,
    is_cron_download: corn.value,
  };
  https
    .whitelist_export({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

//如果没有选中，不能删除
const getSelected = computed(() => selectedRowKeys.value.length === 0);
//select
const selectedRowKeys = ref<Key[]>([]); // Check here to configure the default column
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});
const checkAll = ref(false);
const onSelectAllChange = () => {
  if (checkAll.value) {
    selectedRowKeys.value = whiteList.value.map((e) => e.id);
  } else {
    selectedRowKeys.value = [];
  }
};

const pageConfigure = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总数
  options: ['10', '20', '30', '40', '50'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});
// 获取列表
const whiteList = ref<WhiteObj[]>([]);
const showLoading = ref(false);
const getWhiteList = () => {
  showLoading.value = true;
  const data = { studio_id: studioId, keywords: search.value, page: pageConfigure.current, page_num: pageConfigure.pageSize };
  axios.whiteList
    .getWhiteList({ params: data })
    .then((res) => {
      if (res.data.data.data) whiteList.value = res.data.data.data;
      pageConfigure.totalSize = res.data.data.total;
      pageConfigure.current = res.data.data.current_page;
    })
    .catch((err) => console.error(err))
    .finally(() => (showLoading.value = false));
};
getWhiteList();

// 添加手机号
const loading = ref(false);
const clickCreat = () => {
  loading.value = true;
  axios.whiteList
    .addWhiteList({ studio_id: studioId, mobile: newtel.value })
    .then((res) => {
      message.success(res.data.message);
      show.value = false;
      loading.value = false;
      getWhiteList();
      newtel.value = '';
    })
    .catch((err) => message.error(err.data.error));
};

const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});
const openDelModal = () => {
  delModal.visible = !delModal.visible;
};
// 删除方法
const delSelect = (id: number) => {
  selectedRowKeys.value = [id];
  openDelModal();
};
// 删除手机号
const clickDel = () => {
  delModal.loading = true;
  axios.whiteList
    .delWhiteList({ studio_id: studioId, ids: selectedRowKeys.value.join(',') })
    .then((res) => {
      message.success(res.data.message);
      delModal.loading = false;
      selectedRowKeys.value = [];
      openDelModal();
      getWhiteList();
    })
    .catch((err) => message.error(err.data.error));
};

const delAllModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});
const openAllDelModal = () => {
  delAllModal.visible = !delAllModal.visible;
};
const clickDelAll = () => {
  delAllModal.loading = true;
  axios.whiteList
    .clearWhiteList({ studio_id: studioId })
    .then((res) => {
      message.success(res.data.message);
      delAllModal.loading = false;
      selectedRowKeys.value = [];
      openAllDelModal();
      getWhiteList();
    })
    .catch((err) => message.error(err.data.error));
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_button, {
          type: "primary",
          class: "worp_head_but",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode("添加手机号")
          ]),
          _: 1
        }),
        _createVNode(_unref(aUpload), {
          "file-list": fileList.value,
          "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((fileList).value = $event)),
          name: "excel",
          accept: ".xls,.xlsx,.csv",
          multiple: true,
          action: "/api/v2/live/whitelist_import",
          showUploadList: false,
          data: 
          (file) => ({
            studio_id: _unref(studioId),
          })
        ,
          headers: { token: _unref(token) },
          onChange: _cache[2] || (_cache[2] = (info) => handleChange(info)),
          class: "worp_head_up"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              class: "worp_head_but"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 批量导入")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["file-list", "data", "headers"]),
        _createVNode(_unref(aInputSearch), {
          class: "worp_head_search",
          value: search.value,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((search).value = $event)),
          placeholder: "请输入手机号",
          onKeyup: _withKeys(getWhiteList, ["enter"])
        }, {
          enterButton: _withCtx(() => [
            _createVNode(_component_a_button, null, {
              default: _withCtx(() => [
                _createVNode(_unref(SearchOutlined), {
                  class: "worp_head_search_svg",
                  onClick: getWhiteList
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "onKeyup"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_button, {
            type: "link",
            class: "worp_footer_down",
            onClick: DownloadTemplate
          }, {
            default: _withCtx(() => [
              _createTextVNode("下载Excel模板")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "worp_footer_down",
            onClick: _unref(ExportTemplate),
            disabled: whiteList.value.length < 1
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createElementVNode("p", _hoisted_4, "手机号数量" + _toDisplayString(whiteList.value.length) + "条", 1),
          _createVNode(_component_a_checkbox, {
            checked: checkAll.value,
            "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((checkAll).value = $event)),
            onChange: onSelectAllChange,
            disabled: whiteList.value.length === 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("全选")
            ]),
            _: 1
          }, 8, ["checked", "disabled"]),
          _createVNode(_component_a_button, {
            class: "mod_btn del_boder",
            danger: "",
            disabled: _unref(getSelected),
            onClick: openDelModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 删除 ")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_a_button, {
            class: "mod_btn del_boder",
            onClick: openAllDelModal,
            disabled: whiteList.value.length === 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("清空")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode(CDelModal, {
          visible: delModal.visible,
          centered: "",
          close: openDelModal,
          ok: clickDel,
          loading: delModal.loading
        }, null, 8, ["visible", "loading"]),
        _createVNode(CDelModal, {
          visible: delAllModal.visible,
          centered: "",
          close: openAllDelModal,
          ok: clickDelAll,
          loading: delAllModal.loading
        }, null, 8, ["visible", "loading"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(aTable), {
          columns: columns,
          "data-source": whiteList.value,
          "row-selection": _unref(rowSelection),
          pagination: false,
          rowKey: "id",
          onInput: _cache[5] || (_cache[5] = ($event: any) => (updateForm(1)))
        }, {
          action: _withCtx(({ record }) => [
            _createVNode(_component_a_button, {
              type: "link",
              class: "cancel_but",
              onClick: ($event: any) => (delSelect(record.id))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, { "icon-class": "whiteList_del" }),
                _createTextVNode(_toDisplayString(record.action), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["data-source", "row-selection"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(aPagination), {
          current: pageConfigure.current,
          "onUpdate:current": _cache[6] || (_cache[6] = ($event: any) => ((pageConfigure.current) = $event)),
          pageSize: pageConfigure.pageSize,
          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((pageConfigure.pageSize) = $event)),
          pageSizeOptions: pageConfigure.options,
          total: pageConfigure.totalSize,
          onShowSizeChange: getWhiteList,
          onChange: getWhiteList,
          "show-quick-jumper": "",
          "show-less-items": "",
          "show-size-changer": ""
        }, null, 8, ["current", "pageSize", "pageSizeOptions", "total"])
      ], 512), [
        [_vShow, whiteList.value.length > 0]
      ]),
      _createVNode(_unref(aModal), {
        visible: show.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((show).value = $event)),
        centered: "",
        title: "添加手机号"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            class: "mod_modal_btn",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (show.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            class: "mod_modal_btn mod_type_prmary bg_img",
            onClick: clickCreat,
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _hoisted_7,
            _createVNode(_component_a_input, {
              class: "formNmber",
              value: newtel.value,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((newtel).value = $event)),
              placeholder: "请输入手机号",
              onkeyup: "value=value.replace(/\\D/g,'')",
              maxlength: "11"
            }, null, 8, ["value"])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(aPopover), {
          trigger: "hover",
          placement: "topLeft"
        }, {
          content: _withCtx(() => [
            _hoisted_9
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 唯一登录： ")
          ]),
          _: 1
        }),
        _createVNode(_unref(aRadioGroup), {
          value: _unref(form).loginPoint,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).loginPoint) = $event)),
          onInput: _cache[12] || (_cache[12] = ($event: any) => (updateForm(2)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio, { value: true }, {
              default: _withCtx(() => [
                _createTextVNode("开启")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio, { value: false }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_unref(aPopover), { placement: "right" }, {
          content: _withCtx(() => [
            _hoisted_10
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createTextVNode(" 功能开关： "),
      _createVNode(_component_a_switch, {
        checked: _unref(form).whiteSwitch,
        "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form).whiteSwitch) = $event)),
        onChange: _cache[14] || (_cache[14] = ($event: any) => (updateForm(0)))
      }, null, 8, ["checked"]),
      _createVNode(_unref(aPopover), {
        placement: "right",
        class: "btn_tip"
      }, {
        content: _withCtx(() => [
          _hoisted_12
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})